const CUSTOM_CERT_TYPES = {
  UPLOAD_EXCEL_REQUEST: 'CUSTOM_CERT/UPLOAD_EXCEL_REQUEST',
  UPLOAD_EXCEL_SUCCESS: 'CUSTOM_CERT/UPLOAD_EXCEL_SUCCESS',
  UPLOAD_EXCEL_FAILURE: 'CUSTOM_CERT/UPLOAD_EXCEL_FAILURE',

  FETCH_JOB_STATUS_REQUEST: 'CUSTOM_CERT/FETCH_JOB_STATUS_REQUEST',
  FETCH_JOB_STATUS_SUCCESS: 'CUSTOM_CERT/FETCH_JOB_STATUS_SUCCESS',
  FETCH_JOB_STATUS_FAILURE: 'CUSTOM_CERT/FETCH_JOB_STATUS_FAILURE',

  FETCH_JOBS_LIST_REQUEST: 'CUSTOM_CERT/FETCH_JOBS_LIST_REQUEST',
  FETCH_JOBS_LIST_SUCCESS: 'CUSTOM_CERT/FETCH_JOBS_LIST_SUCCESS',
  FETCH_JOBS_LIST_FAILURE: 'CUSTOM_CERT/FETCH_JOBS_LIST_FAILURE',

  CLEAR_CURRENT_JOB: 'CUSTOM_CERT/CLEAR_CURRENT_JOB',
};

export default CUSTOM_CERT_TYPES;
